import React from "react"
import GUI from "../GUI";

export type TButtonProps = React.ComponentPropsWithoutRef<"button"> & {
    size?:"tiny"|"small"|"medium"|"regular"
    variant?:"contained"|"outlined"|"text"
    color?:"primary"|"secondary"|"alt"
}
export default function Button(props:TButtonProps){
    const {variant,color,children,className,size,...buttonProps} = props
    return <button className={GUI.joinClass("button", className, variant || "text", color || "primary", size || "regular")} {...buttonProps}>{children}</button>
}